import React, { useState } from 'react'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button/Button'
import { ProseInput } from 'common/ProseInput/ProseInput'
import {
  convertHtmlToMarkdown,
  convertMarkdownToHtml,
  ProfileSection,
} from 'screens/BrandKits/components/BrandProfile/markdownUtils'
import { brandProfileSchema } from 'screens/BrandKits/components/BrandProfile/brandProfileSchema'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import styles from './EditableSectionDrawer.module.scss'

interface EditableSectionDrawerProps extends DrawerProps {
  section: ProfileSection
  sectionKey: string
  onSectionUpdate: (sectionKey: string, newContent: string) => void
  isUpdating: boolean
}

export const EditableSectionDrawer = observer(
  ({ section, sectionKey, onSectionUpdate, isUpdating, ...props }: EditableSectionDrawerProps): React.ReactElement => {
    const [localHtmlContent, setLocalHtmlContent] = useState(() =>
      convertMarkdownToHtml(section.content, brandProfileSchema),
    )
    const { drawersStore } = useRootStore()

    const handleSave = () => {
      const markdownContent = convertHtmlToMarkdown(localHtmlContent, brandProfileSchema)
      onSectionUpdate(sectionKey, markdownContent)
      drawersStore.closeDrawer()
    }

    const handleContentChange = (htmlContent: string) => {
      setLocalHtmlContent(htmlContent)
    }
    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Content>
            <div data-vaul-no-drag={true}>
              <Drawer.InnerContent color="var(--light-100)">
                <Drawer.Top>
                  <div></div>
                  <Drawer.Title asChild>
                    <Heading lineClamp={1} level={5}>
                      Edit Brand Profile
                    </Heading>
                  </Drawer.Title>
                  <Drawer.Close label="Cancel" variant="ghost" position="right" />
                  <Drawer.Description />
                </Drawer.Top>
                <Drawer.Container>
                  <div className={styles.container}>
                    <div className={styles.sectionTitle}>
                      <Heading level={3}>{section.title}</Heading>
                    </div>
                    <div className={styles.editorContainer}>
                      <ProseInput
                        initialHtmlString={localHtmlContent}
                        onChange={handleContentChange}
                        placeholder="Enter section content..."
                        schema={brandProfileSchema}
                      />
                    </div>
                    <div className={styles.actionsContainer}>
                      <Button size="xl" fullWidth onPress={handleSave}>
                        Save Changes
                      </Button>
                    </div>
                  </div>
                </Drawer.Container>
              </Drawer.InnerContent>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
